export default __webpack_public_path__ + "static/media/zm.d6412cf3.svg";